import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = {
  class: "text-caption text-truncate",
  style: {"max-width":"200px"}
}
const _hoisted_3 = {
  key: 0,
  class: "text-medium-emphasis text-caption pa-4"
}
const _hoisted_4 = {
  key: 0,
  class: "log-pct"
}

import { ref, nextTick } from 'vue'

interface LogLine {
  level: string
  msg: string
  pct?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PipelinePanel',
  setup(__props) {

const API_BASE = process.env.VUE_APP_API_BASE_URL as string

const docType      = ref<'laws' | 'cases'>('laws')
const files        = ref<File[]>([])
const fileInput    = ref<HTMLInputElement | null>(null)
const isDragging   = ref(false)
const busy         = ref(false)
const activeAction = ref<string>('')
const logs         = ref<LogLine[]>([])
const logEl        = ref<HTMLElement | null>(null)

function onDrop(e: DragEvent) {
  isDragging.value = false
  const dropped = Array.from(e.dataTransfer?.files ?? []).filter(f =>
    f.name.endsWith('.pdf') || f.name.endsWith('.docx')
  )
  files.value.push(...dropped)
}

function onFileInput(e: Event) {
  const input = e.target as HTMLInputElement
  files.value.push(...Array.from(input.files ?? []))
  input.value = ''
}

function removeFile(i: number) {
  files.value.splice(i, 1)
}

function addLog(level: string, msg: string, pct?: number) {
  logs.value.push({ level, msg, pct })
  nextTick(() => {
    if (logEl.value) {
      logEl.value.scrollTop = logEl.value.scrollHeight
    }
  })
}

async function readSSE(response: Response) {
  const reader = response.body!.getReader()
  const decoder = new TextDecoder()
  let buf = ''

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read()
    if (done) break
    buf += decoder.decode(value, { stream: true })
    const parts = buf.split('\n\n')
    buf = parts.pop() ?? ''
    for (const part of parts) {
      const line = part.trim()
      if (line.startsWith('data: ')) {
        try {
          const payload = JSON.parse(line.slice(6))
          addLog(payload.level ?? 'info', payload.msg ?? '', payload.pct)
        } catch {
          addLog('info', line.slice(6))
        }
      }
    }
  }
}

async function runPipeline() {
  busy.value = true
  activeAction.value = 'pipeline'
  addLog('info', `Pipeline başlatılıyor (${docType.value})...`)

  const fd = new FormData()
  fd.append('type', docType.value)
  files.value.forEach(f => fd.append('files[]', f))

  const token = localStorage.getItem('auth_token')

  try {
    const res = await fetch(`${API_BASE}/admin/parser/pipeline/run`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: fd,
    })
    addLog('info', `HTTP status: ${res.status}`)
    await readSSE(res)
    addLog('done', '✓ Pipeline tamamlandı.')
  } catch (e: any) {
    addLog('error', `Hata: ${e.message}`)
  } finally {
    busy.value = false
    activeAction.value = ''
  }
}

async function ssePost(path: string, body: object, label: string) {
  busy.value = true
  activeAction.value = label
  addLog('info', `${label} başlatılıyor...`)

  const token = localStorage.getItem('auth_token')

  try {
    const res = await fetch(`${API_BASE}/admin/parser/${path}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
    await readSSE(res)
    addLog('done', `✓ ${label} tamamlandı.`)
  } catch (e: any) {
    addLog('error', `Hata: ${e.message}`)
  } finally {
    busy.value = false
    activeAction.value = ''
  }
}

function runEnrich(mode: string) {
  ssePost('enrich/run', { mode }, 'enrich')
}

function runRebuild(scope: string) {
  ssePost('index/rebuild', { scope }, 'rebuild')
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        md: "5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-body-1" }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("Dosya Yükle & Çalıştır", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-caption mb-1 text-medium-emphasis" }, "Belge Türü", -1)),
                  _createVNode(_component_v_btn_toggle, {
                    modelValue: docType.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((docType).value = $event)),
                    mandatory: "",
                    color: "primary",
                    variant: "outlined",
                    density: "compact",
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, { value: "laws" }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("Yasa / Tüzük", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, { value: "cases" }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("Mahkeme Kararı", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["drop-zone", { 'drag-over': isDragging.value }]),
                    onDragover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isDragging.value = true), ["prevent"])),
                    onDragleave: _cache[2] || (_cache[2] = ($event: any) => (isDragging.value = false)),
                    onDrop: _withModifiers(onDrop, ["prevent"]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (fileInput.value?.click()))
                  }, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", {
                      class: "material-symbols-outlined",
                      style: {"font-size":"2.5rem","opacity":".5"}
                    }, "upload_file", -1)),
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-body-2 mt-1" }, "PDF veya DOCX dosyalarını sürükleyin", -1)),
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-caption text-medium-emphasis" }, "veya tıklayarak seçin", -1)),
                    _createElementVNode("input", {
                      ref_key: "fileInput",
                      ref: fileInput,
                      type: "file",
                      multiple: "",
                      accept: ".pdf,.docx",
                      style: {"display":"none"},
                      onChange: onFileInput
                    }, null, 544)
                  ], 34),
                  (files.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (f, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "d-flex align-center justify-space-between py-1"
                          }, [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(f.name), 1),
                            _createVNode(_component_v_btn, {
                              icon: "",
                              size: "x-small",
                              variant: "plain",
                              onClick: ($event: any) => (removeFile(i))
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createElementVNode("span", {
                                  class: "material-symbols-outlined",
                                  style: {"font-size":"16px"}
                                }, "close", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    color: "primary",
                    class: "mb-2",
                    disabled: busy.value || files.value.length === 0,
                    loading: busy.value && activeAction.value === 'pipeline',
                    onClick: runPipeline
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("span", { class: "material-symbols-outlined mr-1" }, "play_arrow", -1),
                      _createTextVNode(" Pipeline Çalıştır ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "loading"]),
                  _createVNode(_component_v_btn, {
                    block: "",
                    color: "secondary",
                    variant: "outlined",
                    class: "mb-2",
                    disabled: busy.value,
                    loading: busy.value && activeAction.value === 'enrich',
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (runEnrich('all')))
                  }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createElementVNode("span", { class: "material-symbols-outlined mr-1" }, "auto_awesome", -1),
                      _createTextVNode(" Enrich Çalıştır ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "loading"]),
                  _createVNode(_component_v_menu, null, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        block: "",
                        variant: "outlined",
                        disabled: busy.value
                      }, props), {
                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                          _createElementVNode("span", { class: "material-symbols-outlined mr-1" }, "database", -1),
                          _createTextVNode(" İndeks Yenile ", -1),
                          _createElementVNode("span", { class: "material-symbols-outlined ml-1" }, "arrow_drop_down", -1)
                        ]))]),
                        _: 1
                      }, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { density: "compact" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            title: "Sadece BM25",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (runRebuild('bm25-only')))
                          }),
                          _createVNode(_component_v_list_item, {
                            title: "Yasalar",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (runRebuild('laws')))
                          }),
                          _createVNode(_component_v_list_item, {
                            title: "Kararlar",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (runRebuild('cases')))
                          }),
                          _createVNode(_component_v_list_item, {
                            title: "Tümü",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (runRebuild('all')))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "7"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { style: {"height":"100%"} }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between text-body-1" }, {
                default: _withCtx(() => [
                  _cache[22] || (_cache[22] = _createElementVNode("span", null, "Log", -1)),
                  _createVNode(_component_v_btn, {
                    size: "x-small",
                    variant: "plain",
                    icon: "",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (logs.value = []))
                  }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createElementVNode("span", { class: "material-symbols-outlined" }, "delete_sweep", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { style: {"padding":"0"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    ref_key: "logEl",
                    ref: logEl,
                    class: "log-terminal"
                  }, [
                    (!logs.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Henüz çıktı yok. "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logs.value, (line, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: _normalizeClass(["log-line", `log-${line.level}`])
                      }, [
                        (line.pct !== undefined)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "[" + _toDisplayString(line.pct) + "%]", 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(line.msg), 1)
                      ], 2))
                    }), 128))
                  ], 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})